import { Button, Checkbox, FormControlLabel, FormLabel, makeStyles, Radio, RadioGroup } from '@material-ui/core'
import { isBefore } from 'date-fns'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { format, parseJSON } from 'date-fns'
import React from 'react'
import request from 'request-promise'
import Auth from '../Auth'
import Form from '../Form'
import PageStatus from '../PageStatus'
import baseStyles from './Base.module.css'

const { REACT_APP_API_URI } = process.env

const useStyles = makeStyles({
    input: {
        fontSize: 'inherit',
        fontFamily: 'inherit',
        padding: '1rem',
        display: 'block',
        minWidth: '100%',
        maxWidth: '100%',
    },
    checkbox: {
        '& span': {
            fontSize: 'inherit',
        },
    },
    link: {
        margin: '2rem 0',
        display: 'block',
    },
    buttonWrapper: {
        display: 'flex',
        justifyContent: 'center',
    },
})

const updateForm =
    ({ token }) =>
    async (form) =>
        request({
            uri: `${REACT_APP_API_URI}/forms`,
            method: 'POST',
            body: form,
            json: true,
            headers: { authorization: `Bearer ${token}` },
        })

export default ({ path }) => {
    const styles = useStyles()
    const { form, setForm } = Form.useContainer()
    const { token } = Auth.useContainer()

    const [selectedValue, setSelectedValue] = React.useState(() => {
        if (form.hasOwnProperty(path) && form[path] && form[path].read) {
            return form[path].active ? 'ask' : 'no';
        } else {
            return null;
        }
    });

    const onActiveChange = (event) => {
        const value = event.target.value
        setSelectedValue(value)
        const copyForm = JSON.parse(JSON.stringify(form));
        copyForm[path] = { active: value === 'ask', read: true };
        setForm(copyForm);
        updateForm({ token })(copyForm)
    }

    return (
        <div className={baseStyles.root}>
            <h2>Demande d'équivalence</h2>

            <p>
                En vertu de l’article 3 du{' '}
                <a
                    href="https://res.cloudinary.com/dxvyngy9l/a-propos/cadre-reglementaire/reglement-etudes-bachelor-heig-vd"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    règlement d’études
                </a>{' '}
                de la Haute école d’ingénierie et de gestion du Canton de Vaud ;
            </p>
            <p>
                <strong>L’étudiant qui peut démontrer</strong> l’acquisition, préalablement à ses études, de
                connaissances, voire de compétences correspondantes ou équivalents à celles enseignées dans un module
                peut être mis au bénéfice d’une équivalence de cours.
                <br />
                L’équivalence se traduit par la validation de module (sans note). Les crédits correspondants sont pris
                en compte pour l’octroi du titre.
            </p>
            <p>
                Les demandes d’équivalence doivent être déposées <strong>au moment de la demande d’admission</strong>{' '}
                pour un ou des modules. A moins d'un changement de plan d'étude aucune demande ultérieure ne sera
                acceptée, sauf pour les modules de langues. Par exemple, vous ne pourrez pas demander en fin de 1
                <sup>ère</sup>
                année une équivalence pour des modules de 2<sup>ème</sup>.
            </p>
            <p>
                La demande, qui doit parvenir{' '}
                <strong>
                    avant la fin de la 1<sup>ère</sup> semaine de cours
                </strong>{' '}
                du 1<sup>er</sup> semestre, sera traitée par votre responsable de filière, au plus tard au terme de la 3
                <sup>ème</sup> semaine de cours.
            </p>
            <p>Soyez clair et précis dans la rédaction de votre demande :</p>
            <ol>
                <li>
                    Indiquez <strong>la formation</strong> préalablement suivie pour laquelle vous estimez qu’une
                    demande est possible.
                </li>
                <li>
                    En vous aidant du{' '}
                    <a href="https://gaps.heig-vd.ch/public/plans.php" target="_blank" rel="noopener noreferrer">
                        plan d’étude
                    </a>
                    , indiquez <strong>sous forme de liste</strong>, le(s) module(s) ou le(s) unité(s) pour lesquelles
                    vous faites une demande.
                </li>
            </ol>
            <i>
                Note : Si vous accédez au plan de formation 2025-2026, c'est parce que les plans d'étude 2026-2027 sont encore en cours d'élaboration. Néanmoins il y a généralement peu de différence et vous pouvez donc faire votre demande d'équivalence pour 2026-2027 en vous basant sur le plan 2025-2026.
            </i>
            <br /> <br />

            <FormLabel id='radio-demande' style={{padding: '5px 10px'}}>Sélectionner une des options suivantes</FormLabel>
            <RadioGroup
              aria-labelledby='radio-demande'
              name='demande-equivalence'
              value={selectedValue}
              onChange={onActiveChange}
            >
                <FormControlLabel value='ask' control={<Radio />} label='Faire une demande' />
                {selectedValue === 'ask' && (
                  <>
                      {isBefore(new Date(), new Date(2026, 8, 1)) ? (
                          <Button variant="contained" disabled>
                              L'ACCÈS À LA PLATEFORME DE DEMANDE D'ÉQUIVALENCE SERA OUVERT EN SEPTEMBRE
                          </Button>
                      ) : (
                          <Button
                              variant="contained"
                              color="primary"
                              href="https://equivalences.heig-vd.ch"
                              target="_blank"
                              rel="noopener noreferrer"
                          >
                              ACCÉDER À LA PLATEFORME DE DEMANDE D'ÉQUIVALENCE
                          </Button>
                      )}
                      <Equivalences token={token} />
                  </>
                )}
                <FormControlLabel value='no' control={<Radio />} label='Ne pas faire une demande' />
            </RadioGroup>

        </div>
    )
}

const Equivalences = ({ token }) => {
    const styles = makeStyles({
        root: { marginTop: '32px' },
    })()

    const [data, setData] = React.useState([])

    React.useEffect(() => {
        const fetch = async () => {
            const uri = `${REACT_APP_API_URI}/equivalences/equivalences-aloha`
            try {
                const res = await request({
                  uri,
                  method: 'GET',
                  json: true,
                  headers: { authorization: `Bearer ${token}` },
                })
                setData(res)
            } catch (e) {
              console.log(e)
            }
        }
        fetch()
    }, [token])

    return data.length > 0 ? (
        <div className={styles.root}>
            <h3>Statut de vos demandes</h3>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Modules</TableCell>
                            <TableCell>Statut</TableCell>
                            <TableCell>Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <TableRow key={row.createdAt}>
                                <TableCell component="th" scope="row">
                                    {row.modules.join(', ')}
                                </TableCell>
                                <TableCell>{row.status}</TableCell>
                                <TableCell>{format(parseJSON(row.createdAt), 'dd.MM.yyyy')}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    ) : null
}
